import React from "react";
import ImageLightbox from "../../common/ImageLightbox";

const getFullPollImageUrl = (url) => {
    if (!url || !url.includes("/pools/") || /-full\.jpg(\?|$)/i.test(url)) return url;
    return url.replace(/\.jpg(\?|$)/i, "-full.jpg$1");
};

const PollsPhotoZoom = ({show, onClose, photo}) => {
    const previewSrc = show ? photo : null;
    const fullSrc = previewSrc ? getFullPollImageUrl(previewSrc) : null;

    return (
        <ImageLightbox
            src={fullSrc}
            fallbackSrc={previewSrc}
            alt="Full size image"
            onClose={onClose}
        />
    );
};

export default PollsPhotoZoom;
